import script from "./TheNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./TheNavigation.vue?vue&type=style&index=0&id=a9b6fd24&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b6fd24"]])

export default __exports__